import { Directive, ElementRef, HostListener, EventEmitter, Input, Output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[HorizontalResize]'
})
export class HorizontalResizeDirective {

  @Input() resizeTarget!: HTMLElement;
  @Input() resizeContainer!: HTMLElement;

  @Input() minWidth = 250;
  @Input() rightReservedWidth = 100;
  @Input() shouldRender: boolean = true;
  @Output() resized = new EventEmitter<number>();

  private resizing = false;
  private isRendered: boolean = true;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) { }

  @HostListener('mousedown', ['$event'])
  startResize(event: MouseEvent): void {
    event.preventDefault();

    if (!this.resizeTarget || !this.resizeContainer) {
      return;
    }

    this.resizing = true;

    this.renderer.setStyle(document.body, 'cursor', 'col-resize');
    this.renderer.setStyle(document.body, 'user-select', 'none');
  }

  @HostListener('document:mousemove', ['$event'])
  resize(event: MouseEvent): void {
    if (!this.resizing) {
      return;
    }

    const containerRect = this.resizeContainer.getBoundingClientRect();
    const newWidth = event.clientX - containerRect.left;
    const maxWidth = containerRect.width - this.rightReservedWidth;

    const width = Math.max(this.minWidth, Math.min(newWidth, maxWidth));

    this.renderer.setStyle(this.resizeTarget, 'width', `${width}px`);
    this.resized.emit(width);
  }

  @HostListener('document:mouseup')
  stopResize(): void {
    if (!this.resizing) {
      return;
    }

    this.resizing = false;

    this.renderer.removeStyle(document.body, 'cursor');
    this.renderer.removeStyle(document.body, 'user-select');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (!this.shouldRender && this.isRendered) {
      this.renderer.setStyle(this.resizeTarget, 'width', `0px`);
      this.isRendered = false;
    } else if (this.shouldRender && !this.isRendered) {
      const containerRect = this.resizeContainer.getBoundingClientRect();
      const newWidth = event.clientX - containerRect.left;
      const maxWidth = containerRect.width - this.rightReservedWidth;

      const width = !newWidth ? this.minWidth : Math.max(this.minWidth, Math.min(newWidth, maxWidth));

      this.renderer.setStyle(this.resizeTarget, 'width', `${width}px`);

      this.isRendered = true;
    }
  }
}